export const compareOnlyPathName = (prevLocation, nextLocation) =>
  (prevLocation && prevLocation.pathname) !== (nextLocation && nextLocation.pathname);
